import React, { useState, useEffect } from "react";
import {
  Companydata,
  getCompanyApi,
  getadminReferralCode,
  UpdateDefaultAdmin,
  updateCompanyData,
} from "../../../Services/Superadmin/Superadmin";
import Swal from "sweetalert2";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const Settings = () => {
  const [plan, setPlan] = useState({
    Basic_plan: "",
    Standard_plan: "",
    Premium_plan: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [data, setData] = useState([]);
  const [DefaultAdmin, setDefaultAdmin] = useState("");
  const [userid, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");

  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;

  useEffect(() => {
    getCompanyData();
    getAllAdmin();
  }, []);

  const getCompanyData = async () => {
    try {
      const res = await getCompanyApi();
      if (res?.status) {
        setPlan({
          Basic_plan: res?.data?.Basic_plan,
          Standard_plan: res?.data?.Standard_plan,
          Premium_plan: res?.data?.Premium_plan,
        });
        setDefaultAdmin(res?.data?.DefaultAdmin);
      }
    } catch (error) {
      console.error("Failed to fetch company data:", error);
    }
  };

  const getAllAdmin = async () => {
    const payload = { id: user_id };
    try {
      const response = await getadminReferralCode(payload);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching admin data:", error);
    }
  };

  const validateField = (name, value) => {
    let errorMsg = "";
    if (!value || value.toString().trim() === "") {
      errorMsg = "This field is required.";
    }
    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlan((prev) => ({ ...prev, [name]: value }));
    if (touched[name]) validateField(name, value);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    validateField(name, value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    Object.keys(plan).forEach((key) => {
      if (!plan[key] || plan[key].toString().trim() === "") {
        newErrors[key] = "This field is required.";
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setTouched({
        Basic_plan: true,
        Standard_plan: true,
        Premium_plan: true,
      });
      return;
    }

    try {
      const res = await Companydata(plan);
      if (res.status) {
        Swal.fire({
          title: "Success",
          text: res.message || "Plan updated successfully",
          icon: "success",
          timer: 1000,
          timerProgressBar: true,
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: res.message,
          icon: "error",
          timer: 1000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong.",
        icon: "error",
      });
    }
  };

  const UpdateAdminReferalCode = async (e) => {
    e.preventDefault();
    if (!DefaultAdmin) {
      setErrors({ DefaultAdmin: "Please select an admin" });
      setTouched({ DefaultAdmin: true });
      return;
    }

    try {
      const res = await UpdateDefaultAdmin({ DefaultAdmin });
      if (res.status) {
        Swal.fire({
          title: "Success",
          text: res.message || "Default admin updated successfully",
          icon: "success",
          timer: 1000,
          timerProgressBar: true,
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: res.message,
          icon: "error",
          timer: 1000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong.",
        icon: "error",
      });
    }
  };

  const UpdateCompanyDataApi = async (e) => {
    e.preventDefault();

    let UpdateData = {};
    if (userid) UpdateData.userid = userid;
    if (password) UpdateData.password = password;
    if (totp) UpdateData.totp_secret = totp;

    try {
      const res = await updateCompanyData(UpdateData);
      if (res.status) {
        Swal.fire({
          title: "Success",
          text: res.message || "Company data updated successfully",
          icon: "success",
          timer: 1000,
          timerProgressBar: true,
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: res.message,
          icon: "error",
          timer: 1000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong.",
        icon: "error",
      });
    }
  };

  return (
    <div
      className="container-fluid"
    
    >
      <div className="card transaction-table custom-bg">
      <div className="row justify-content-center">
        <div className="col-xl-12 col-lg-12">
          <div className="card shadow-sm border-0 rounded-4">
            {/* HEADER */}
            <div className="card-header border-0 rounded-top-4 px-4 pt-3 pb-2">
              <div>
              <h4 className="card-title mb-0 d-flex align-items-center gap-2">
                <span role="img" aria-label="settings">
                  ⚙️
                </span>
                Settings
              </h4>
              <p className="text-muted small mb-0">
                Manage global plan prices and default referral admin for your
                platform.
              </p>
              </div>
            </div>
            <hr className="mt-0 mb-0" />

            {/* BODY */}
            <div className="card-body px-4 pt-4 pb-4">
              <div className="row g-4">
                {/* Update Plans */}
                <div className="col-xl-6 col-lg-6">
                  <div className="bg-white border rounded-4 shadow-sm h-100 p-4">
                    <h5 className="mb-2 text-center">Update Plans</h5>
                    <p className="text-muted small text-center mb-4">
                      Set pricing for Basic, Standard, and Premium plans.
                    </p>

                    {["Basic_plan", "Standard_plan", "Premium_plan"].map(
                      (field) => {
                        const label = field
                          .replace("_plan", "")
                          .replace("_", " ");
                        return (
                          <div className="mb-3" key={field}>
                            <label
                              htmlFor={field}
                              className="form-label fw-semibold"
                            >
                              {label} Plan
                            </label>
                            <input
                              id={field}
                              name={field}
                              type="number"
                              value={plan[field] || ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`form-control ${
                                errors[field] && touched[field]
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder={`Enter ${label} plan price`}
                            />
                            {errors[field] && touched[field] && (
                              <div className="invalid-feedback">
                                {errors[field]}
                              </div>
                            )}
                          </div>
                        );
                      }
                    )}

                    <button
                      type="button"
                      className="btn btn-primary w-100 mt-2"
                      onClick={handleSubmit}
                    >
                      Save Plan Prices
                    </button>
                  </div>
                </div>

                {/* Update Default Admin */}
                <div className="col-xl-6 col-lg-6">
                  <div className="bg-white border rounded-4 shadow-sm h-100 p-4">
                    <h5 className="mb-2 text-center">
                      Default Admin for Referral
                    </h5>
                    <p className="text-muted small text-center mb-4">
                      Choose which admin’s referral code will be used by
                      default.
                    </p>

                    <div className="mb-3">
                      <label
                        htmlFor="DefaultAdmin"
                        className="form-label fw-semibold"
                      >
                        Default Admin
                      </label>
                      <select
                        id="DefaultAdmin"
                        name="DefaultAdmin"
                        value={DefaultAdmin || ""}
                        onChange={(e) => setDefaultAdmin(e.target.value)}
                        onBlur={handleBlur}
                        className={`form-select ${
                          errors.DefaultAdmin && touched.DefaultAdmin
                            ? "is-invalid"
                            : ""
                        }`}
                      >
                        <option value="" disabled>
                          Select Admin
                        </option>
                        {data?.map((admin) => (
                          <option
                            key={admin.id || admin._id || admin.ReferralCode}
                            value={admin.ReferralCode}
                          >
                            {admin.FullName} ({admin.ReferralCode})
                          </option>
                        ))}
                      </select>
                      {errors.DefaultAdmin && touched.DefaultAdmin && (
                        <div className="invalid-feedback">
                          {errors.DefaultAdmin}
                        </div>
                      )}
                    </div>

                    <button
                      type="button"
                      className="btn btn-primary w-100 mt-2"
                      onClick={UpdateAdminReferalCode}
                    >
                      Save Default Admin
                    </button>
                  </div>
                </div>

                {/* Optional: Company Credentials (user/pass/totp) */}
                {/* <div className="col-xl-4 col-lg-12">
                  <div className="bg-white border rounded-4 shadow-sm h-100 p-4">
                    <h5 className="mb-2 text-center">Company Credentials</h5>
                    <p className="text-muted small text-center mb-4">
                      Update optional credentials like User ID, Password and
                      TOTP secret (if required).
                    </p>

                    <form onSubmit={UpdateCompanyDataApi}>
                      <div className="mb-3">
                        <label
                          htmlFor="userid"
                          className="form-label fw-semibold"
                        >
                          User ID
                        </label>
                        <input
                          id="userid"
                          type="text"
                          className="form-control"
                          value={userid}
                          onChange={(e) => setUserId(e.target.value)}
                          placeholder="Enter User ID (optional)"
                        />
                      </div>

                      <div className="mb-3">
                        <label
                          htmlFor="password"
                          className="form-label fw-semibold"
                        >
                          Password
                        </label>
                        <input
                          id="password"
                          type="password"
                          className="form-control"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Enter Password (optional)"
                        />
                      </div>

                      <div className="mb-3">
                        <label
                          htmlFor="totp"
                          className="form-label fw-semibold"
                        >
                          TOTP Secret
                        </label>
                        <input
                          id="totp"
                          type="text"
                          className="form-control"
                          value={totp}
                          onChange={(e) => setTotp(e.target.value)}
                          placeholder="Enter TOTP Secret (optional)"
                        />
                      </div>

                      <button
                        type="submit"
                        className="btn btn-outline-primary w-100 mt-2"
                      >
                        Save Company Data
                      </button>
                    </form>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Optional footer */}
            {/* <div className="card-footer bg-white border-0 text-end px-4 pb-3">
              <small className="text-muted">
                Changes apply globally across the platform.
              </small>
            </div> */}
          </div>
        </div>
      </div>
     </div>
    </div>
  );
};

export default Settings;
